// ======================================================================
// File: src/modules/ppe/components/orders/OrdersPagination.js
// ======================================================================

import React from "react";

export default function OrdersPagination({
  page,
  pageSize,
  total,
  onPageChange,
  onPageSizeChange,
}) {
  const pages = Math.ceil(total / pageSize);
  if (pages <= 1) return null;

  return (
    <div className="d-flex justify-content-between align-items-center mt-3">

      <select
        className="form-select"
        style={{ width: 120 }}
        value={pageSize}
        onChange={(e) => onPageSizeChange(Number(e.target.value))}
      >
        <option value={10}>10 / page</option>
        <option value={20}>20 / page</option>
        <option value={50}>50 / page</option>
      </select>

      <div>
        <button
          className="btn btn-sm btn-secondary me-2"
          disabled={page === 1}
          onClick={() => onPageChange(page - 1)}
        >
          Prev
        </button>

        <span>
          Page {page} of {pages}
        </span>

        <button
          className="btn btn-sm btn-secondary ms-2"
          disabled={page === pages}
          onClick={() => onPageChange(page + 1)}
        >
          Next
        </button>
      </div>
    </div>
  );
}
